import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
	BasicSelect
} from 'vue-search-select';
import moment from 'moment'
import DatePicker from 'vue2-datepicker'

export default {
	name: 'inscan-shortage-shipment',
	components: {
		VueElementLoading,
		BasicSelect,
    DatePicker
	},
	props: [],
	data() {
		return {
			isLoading: false,

      showTable:false,
      ConnectionIDError:'',
      vehicleNoError:'',
      thcNoError:'',
      fromdate:'',
      todate:'',
      toDateError:'',
      fromDateError:'',
      csmidradio: '',
      thcNo: '',
      vehicleNo: '',
      connectionDetails:[],
      checkedType:''

		}
	},
	computed: {},
	mounted() {
		var userTokenEncrypt = window.localStorage.getItem('userToken')
		var userTokenDecrypt = CryptoJS.AES.decrypt(userTokenEncrypt.toString(), 'Key');
		var userToken = userTokenDecrypt.toString(CryptoJS.enc.Utf8);
		this.token = JSON.parse(userToken)
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.hubid = userdetail[0].HubId[0];
		this.createdbyemail = userdetail[0].email;
	},
	methods: {
		checkConnectionId() {
      if (this.csmidradio == '' || this.csmidradio == '') {
				this.ConnectionIDError = 'The Connection Schedule master id field is required.'
			} else {
				this.ConnectionIDError = ''
			}
      if (this.fromdate == '' || this.fromdate == '') {
        this.fromDateError = 'The from date field is required.'
      } else {
        this.fromDateError = ''
      }
      if (this.todate == '' || this.todate == '') {
        this.toDateError = 'The to date field is required.'
      } else {
        this.toDateError = ''
      }
      if (this.csmidradio == '' || this.csmidradio == '' || this.fromdate == '' || this.fromdate == '' || this.todate == '' || this.todate == '') {
        return false;
      }
      this.loadConnectionDetails()
		},

    checkThcNo() {
      if (this.thcNo == '' || this.thcNo == '') {
        this.thcNoError = 'The THC NO field is required.'
      } else {
        this.thcNoError = ''
      }
      if (this.fromdate == '' || this.fromdate == '') {
        this.fromDateError = 'The from date field is required.'
      } else {
        this.fromDateError = ''
      }
      if (this.todate == '' || this.todate == '') {
        this.toDateError = 'The to date field is required.'
      } else {
        this.toDateError = ''
      }
      if (this.thcNo == '' || this.thcNo == '' || this.fromdate == '' || this.fromdate == '' || this.todate == '' || this.todate == '') {
        return false;
      }
      this.loadConnectionDetails()
    },

    checkVehicleNo() {
      if (this.vehicleNo == '' || this.vehicleNo == '') {
        this.vehicleNoError = 'The Vehicle No field is required.'
      } else {
        this.vehicleNoError = ''
      }
      if (this.fromdate == '' || this.fromdate == '') {
        this.fromDateError = 'The from date field is required.'
      } else {
        this.fromDateError = ''
      }
      if (this.todate == '' || this.todate == '') {
        this.toDateError = 'The to date field is required.'
      } else {
        this.toDateError = ''
      }
      if (this.vehicleNo == '' || this.vehicleNo == '' || this.fromdate == '' || this.fromdate == '' || this.todate == '' || this.todate == '') {
        return false;
      }
      this.loadConnectionDetails()
    },

    loadConnectionDetails() {
          this.isLoadingSearch = true
          this.input = {}
					let url;
					if(this.csmidradio)
					{
						url = apiUrl.api_url_hubops + 'getConnectionScheduleDetails?ConnectionScheduleMasterId=' + this.csmidradio +'&FromDate='+this.fromdate +'&ToDate	='+this.todate;
					}

					if(this.thcNo)
					{
					 url = apiUrl.api_url_hubops + 'getConnectionScheduleDetails?ThcNo=' + this.thcNo +'&FromDate='+this.fromdate +'&ToDate	='+this.todate;
					}

					if(this.vehicleNo)
					{
					 url = apiUrl.api_url_hubops + 'getConnectionScheduleDetails?VehicleNo=' + this.vehicleNo +'&FromDate='+this.fromdate +'&ToDate	='+this.todate;
					}

					axios({
              method: 'GET',
              'url': url,
              'data': this.input,
              headers: {
                'Authorization': 'authkey xB84JJ89Hd25'
              }
            })
            .then(result => {
              if (result.data.ResultCode == 100) {
                  this.isLoadingSearch = false;
                  this.showTable = true;
                  this.connectionDetails = result.data.ResponseData;
									this.$alertify.success(result.data.ReturnMessage)
              } else {
                this.showTable = false;
                this.$alertify.error(result.data.ReturnMessage)
              }
              this.isLoading = false
            },error => {
	            self.isLoadingSearch = false;
	            //this.$alertify.error("Fetch Connection API error")
	            this.$alert("Fetch Connection API error", "", "error");
	            console.error(error)
	          })
        //}
      //});
    },

		checkField() {
			this.csmidradio = ''
			this.thcNo = ''
			this.vehicleNo = ''
			this.ConnectionIDError = ''
			this.thcNoError = ''
			this.vehicleNoError = ''
			this.fromDateError = ''
			this.toDateError = ''
      this.fromdate=''
      this.todate=''
      this.showTable=false

		},
    resetForm(){
      this.connectionDetails=[]
      this.csmidradio = ''
      this.thcNo = ''
      this.vehicleNo = ''
      this.ConnectionIDError = ''
      this.thcNoError = ''
      this.vehicleNoError = ''
      this.fromDateError = ''
      this.toDateError = ''
      this.fromdate=''
      this.todate=''
      this.showTable=false
    },
		onSubmit: function(event) {
			this.$validator.validateAll().then((result) => {
				if (!result) {
					return false;
				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/FetchConnectionDetails/FetchConnectionDetails.js